import { TApplicationState } from '../../types/redux';

export function selectRealtyValuationData(state: TApplicationState) {
  return state.realtyValuation.data;
}

export function selectRealtyValuationDataFetching(state: TApplicationState) {
  return state.realtyValuation.isFetching;
}

export function selectRealtyValuationTabs(state: TApplicationState) {
  return state.realtyValuation.tabs;
}

export const selectPricesFiltersData = (state: TApplicationState) => {
  return state.realtyValuation.data?.pricesFiltersData;
};

export const selectSalesFiltersData = (state: TApplicationState) => {
  return state.realtyValuation.data?.salesFiltersData;
};

export const selectPricesFiltersState = (state: TApplicationState) => {
  return state.realtyValuation.pricesFiltersState;
};

export const selectSalesFiltersState = (state: TApplicationState) => {
  return state.realtyValuation.salesFiltersState;
};
